import axios from "./axios"; // Import the centralized Axios instance
import prm from "./prm";

const state = {
  bill_of_material_details: [],
};

const getters = {
  allBillOfMaterialDetails: (state) => state.bill_of_material_details,
};

const actions = {
  async fetchBillOfMaterialDetails({ commit }, params = {}) {
    try {
      const response = await axios.get("/bill-of-material-detail", { params: prm(params) });
      commit("setBillOfMaterialDetails", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch bill_of_material_details:", error);
    }
  },
  async createBillOfMaterialDetail({ commit }, bill_of_material_detail) {
    try {
      const response = await axios.post("/bill-of-material-detail", bill_of_material_detail);
      commit("addBillOfMaterialDetail", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to create bill_of_material_detail:", error);
      throw error;
    }
  },
  async fetchBillOfMaterialDetailById(_, id) {
    try {
      const response = await axios.get(`/bill-of-material-detail/${id}`);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch bill_of_material_detail:", error);
      throw error;
    }
  },
  async updateBillOfMaterialDetail({ commit }, bill_of_material_detail) {
    try {
      const response = await axios.put(`/bill-of-material-detail/${bill_of_material_detail.id}`, bill_of_material_detail);
      commit("updateBillOfMaterialDetail", response.data);
    } catch (error) {
      console.error("Failed to update bill_of_material_detail:", error);
      throw error;
    }
  },
  async deleteBillOfMaterialDetailById({ commit }, id) {
    try {
      const response = await axios.delete(`/bill-of-material-detail/${id}`);
      commit("removeBillOfMaterialDetail", id);
      return response.data;
    } catch (error) {
      console.error("Failed to delete bill_of_material_detail:", error);
      throw error;
    }
  },
};

const mutations = {
  setBillOfMaterialDetails(state, bill_of_material_details) {
    state.bill_of_material_details = bill_of_material_details.data; // Ensure this matches your API's response structure
  },
  addBillOfMaterialDetail(state, bill_of_material_detail) {
    state.bill_of_material_details.push(bill_of_material_detail);
  },
  updateBillOfMaterialDetail(state, updatedBillOfMaterialDetail) {
    const index = state.bill_of_material_details.findIndex(
      (bill_of_material_detail) => bill_of_material_detail.id === updatedBillOfMaterialDetail.id
    );
    if (index !== -1) {
      state.bill_of_material_details.splice(index, 1, updatedBillOfMaterialDetail);
    }
  },
  removeBillOfMaterialDetail(state, id) {
    state.bill_of_material_details = state.bill_of_material_details.filter(
      (bill_of_material_detail) => bill_of_material_detail.id !== id
    );
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
